module.exports = __webpack_public_path__ + "img/SOUTHASIA_LOW_GLYCEMIC.56cae489.png";